<template>
  <div class="film-section">
    <p class="p1">— {{ $t("home.v2.film.p1") }} —</p>
    <p class="p2">{{ $t("home.v2.film.title1") }}</p>
    <p class="p2">{{ $t("home.v2.film.title2") }}</p>
    <p class="p3">
      {{ $t("home.v2.film.desc") }}
    </p>
    <p class="p4" ref="playBtn" @click="openVideoDialog">
      <img src="@/assets/img/images/home/play.png" alt="" />
      {{ $t("home.v2.film.btn") }}
    </p>
    <!-- 视频弹窗：fade 过渡 + 点击遮罩区域关闭 -->
    <transition name="video-fade">
      <div class="video-modal" v-if="dialogVisible" @click="closeVideo">
        <div class="video-dialog" :style="dialogStyle" @click.stop>
          <video
            ref="filmVideo"
            class="film-video"
            controls
            loop
            playsinline
            webkit-playsinline
          ></video>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import Hls from "hls.js";

export default {
  name: "FilmSection",
  data() {
    return {
      dialogVisible: false,
      dialogStyle: {},
    };
  },
  mounted() {},

  beforeDestroy() {
    if (this.hls) {
      this.hls.destroy();
      this.hls = null;
    }
  },
  methods: {
    // 供 HeroSection 按钮调用：仅滚动到视频区域，不自动弹窗
    playVideo() {
      this.$el.scrollIntoView({ behavior: "smooth", block: "start" });
    },
    // 点击播放按钮：打开弹窗并播放
    openVideoDialog() {
      this.calcDialogPosition();
      this.dialogVisible = true;
      this.$nextTick(() => {
        this.initVideo();
        const video = this.$refs.filmVideo;
        if (video && video.paused) {
          video.play().catch(() => {});
        }
      });
    },
    // 根据播放按钮位置计算弹窗定位与尺寸，完全由 JS 控制避免 CSS/JS 不同步
    calcDialogPosition() {
      const btn = this.$refs.playBtn;
      if (!btn) return;
      const rect = btn.getBoundingClientRect();
      const winW = window.innerWidth;
      const winH = window.innerHeight;
      // iPhone Safari 的 orientation: portrait 不可靠，改用纯宽度判断
      const isMobile = winW <= 768;
      // 固定尺寸：PC 800×450（16:9），手机 90vw × 50vh
      const dialogW = isMobile ? Math.floor(winW * 0.9) : 800;
      const dialogH = isMobile ? Math.floor(winH * 0.5) : 450;
      // 水平：弹窗中心对齐按钮中心，限制不超出窗口左右边距 16px
      let left = Math.round(rect.left + rect.width / 2 - dialogW / 2);
      left = Math.max(16, Math.min(left, winW - dialogW - 16));
      // 垂直：优先按钮上方 16px；上方放不下则放按钮下方；下方也放不下则垂直居中
      const spacing = 16;
      let top = rect.top - dialogH - spacing;
      if (top < 16) {
        top = rect.bottom + spacing;
        if (top + dialogH > winH - 16) {
          top = Math.max(16, Math.round((winH - dialogH) / 2));
        }
      }
      this.dialogStyle = {
        position: "fixed",
        left: left + "px",
        top: top + "px",
        width: dialogW + "px",
        height: dialogH + "px",
      };
    },
    // 点击遮罩关闭弹窗，暂停播放并销毁 hls
    closeVideo() {
      this.dialogVisible = false;
      const video = this.$refs.filmVideo;
      if (video) {
        video.pause();
      }
      if (this.hls) {
        this.hls.destroy();
        this.hls = null;
      }
    },
    initVideo() {
      const video = this.$refs.filmVideo;
      if (!video) return;
      // 本地 hls 文件流地址（m3u8 及 ts 分片文件放在 public/video/ 目录下）
      // 中文环境播放中文版，其他语言播放英文版
      const videoName = (this.$i18n.locale || "").indexOf("zh") === 0
        ? "film-cn"
        : "film-en";
      const src = process.env.BASE_URL + "video/" + videoName + ".m3u8";
      if (Hls.isSupported()) {
        // Chrome / Edge / Firefox / 安卓 WebView：通过 MSE 加载 HLS
        this.hls = new Hls();
        this.hls.loadSource(src);
        this.hls.attachMedia(video);
      } else if (video.canPlayType("application/vnd.apple.mpegurl")) {
        // Safari / iOS：原生支持 HLS，直接设置 src
        video.src = src;
      }
    },
  },
};
</script>

<style lang="less" scoped>
.film-section {
  width: 100%;
  height: 1081px;
  display: flex;
  align-items: center;
  flex-direction: column;
  box-sizing: border-box;
  justify-content: center;
  background-size: 100% 100%;
  background-image: url("../../../assets/img/images/home/film-bj.png");
  .p1 {
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 18px;
    color: #ffffff;
    margin-bottom: 8px;
  }
  .p2 {
    font-family: Microsoft YaHei, Microsoft YaHei;
    font-weight: bold;
    font-size: clamp(32px, 2.75vw, 60px);
    color: #ffffff;
    line-height: 60px;
  }
  .p3 {
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 22px;
    color: #ffffff;
    margin-top: 16px;
  }
  .p4 {
    display: flex;
    align-items: center;
    cursor: pointer;
    font-family: PingFang SC, PingFang SC;
    font-weight: bold;
    font-size: 24px;
    color: #ffffff;
    margin-top: 60px;
    img {
      width: 32px;
      height: 32px;
      margin-right: 20px;
    }
  }
  // 视频弹窗：全屏遮罩，弹窗尺寸与位置完全由 JS 控制
  .video-modal {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.7);
    z-index: 9999;
    .video-dialog {
      border-radius: 12px;
      overflow: hidden;
      background: #000000;
      .film-video {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        object-fit: cover;
        display: block;
      }
    }
  }
}
// fade 过渡动画
.video-fade-enter-active,
.video-fade-leave-active {
  transition: opacity 0.3s ease;
  .video-dialog {
    transition: transform 0.3s ease;
  }
}
.video-fade-enter,
.video-fade-leave-to {
  opacity: 0;
  .video-dialog {
    transform: scale(0.95);
  }
}
</style>
